var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "page-base__all" },
    [
      _vm.loading ? _c("sc-page-loading") : _vm._e(),
      _vm._v(" "),
      _vm.showBack || _vm.showBackText
        ? _c(
            "div",
            { staticClass: "page-base__btn-back", on: { click: _vm.back } },
            [
              _c(
                "div",
                [
                  _c("sc-icon", {
                    attrs: {
                      pack: "fas",
                      icon: "chevron-left",
                      size: "is-small"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "page-base__btn-back__text" }, [
                _vm._v(_vm._s(_vm.showBackText))
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.title
        ? _c("h1", { staticClass: "page-base__title has-text-primary" }, [
            _vm._v(_vm._s(_vm.title) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.title
        ? _c(
            "div",
            {
              staticClass:
                "page-base__title has-text-primary has-text-weight-bold"
            },
            [
              _c("div", [_vm._t("titleLeft")], 2),
              _vm._v(" "),
              _c("div", [_vm._t("titleRight")], 2)
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.subTitle
        ? _c("h2", { staticClass: "subtitle" }, [
            _vm.openSubtitle
              ? _c("span", [
                  _vm._v(_vm._s(_vm.subTitle) + " "),
                  _vm.openSubtitle
                    ? _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.openSubtitle = false
                            }
                          }
                        },
                        [_vm._v("Ocultar")]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.openSubtitle
              ? _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.openSubtitle = !_vm.openSubtitle
                      }
                    }
                  },
                  [_vm._v("Saiba mais")]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.subTitle ? _vm._t("subtitleSection") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-content", class: { box: _vm.box } },
        [_vm._t("default")],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a374ef6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a374ef6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/components/new-page-base/NewPageBase.vue
// module id = null
// module chunks = 